import { render } from "./CallMediasDoughnutChart.vue?vue&type=template&id=718c68a5&ts=true"
import script from "./CallMediasDoughnutChart.vue?vue&type=script&lang=ts&setup=true"
export * from "./CallMediasDoughnutChart.vue?vue&type=script&lang=ts&setup=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/charts/CallMediasDoughnutChart.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "718c68a5"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('718c68a5', __exports__)) {
    api.reload('718c68a5', __exports__)
  }
  
  module.hot.accept("./CallMediasDoughnutChart.vue?vue&type=template&id=718c68a5&ts=true", () => {
    api.rerender('718c68a5', render)
  })

}


export default __exports__